import formatMetricWithThreshold from 'utils/formatMetricWithThreshold';

// Formats an arrival count against the minimum expected and the period it was measured over, e.g.
// "418 (10) over 60 min". The period matters because each queue declares its own, so a count on its
// own says nothing about the rate. A count reported without a usable period is shown without one, as
// is a count that was not reported at all. A period of zero or less is treated as no period rather
// than printed: nothing arriving during no elapsed time is not a measurement.
export default function formatArrivalsOverWindow(arrivals, minimumExpected, windowMinutes) {
    const metric = formatMetricWithThreshold(arrivals, minimumExpected);

    if (arrivals == null || windowMinutes == null || windowMinutes <= 0) {
        return metric;
    }

    return `${metric} over ${windowMinutes} min`;
}
